import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import HomeButton from "../../components/Buttons/HomeButton/HomeButton";
import ContentKey from "../../components/ContentKey/ContentKey";
import ApiErrorModal from "../../components/Modals/ApiErrorModal/ApiErrorModal";
import FirebaseService from "../../core/services/firebase.service";
import ContentKeys from "../../core/utilities/contentKeys";
import { withRouter, WithRouterProps } from "../../core/utilities/hooks";
import { Images } from "../../core/utilities/images";
import { IStore } from "../../core/utilities/reducers";
import { router } from "../../core/utilities/router";
import "./LandingPage.scss";

interface IProps {
  contents: Map<string, string>;
}

class LandingPage extends React.Component<WithRouterProps<IProps>> {
  private handleHome() {
    FirebaseService.logEvent(
      FirebaseService.user_count_kmb_homepage_start_click
    );
    this.props.navigate(router.HOME);
  }

  render() {
    return (
      <div id="landing-page" className="page">
        <div className="page-content">
          <div className="body">
            <img className="logo" src={Images.logo_kgb_app} alt="logo" />
            <ContentKey
              className="text"
              contentKey={ContentKeys.HOMEPAGE_TEXT}
            />
            <HomeButton
              child={
                <ContentKey contentKey={ContentKeys.HOMEPAGE_START_BUTTON} />
              }
              callback={() => this.handleHome()}
            />
          </div>
        </div>
        <ApiErrorModal />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({}, dispatch);
};
const mapStateToProps = (store: IStore) => {
  return {
    contents: store.getContents.data,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<IProps>(LandingPage));
